import { format, parseISO } from 'date-fns';

import { TranslationService } from '@asteria/language';
import * as FormatUtils from '@asteria/utils-funcs/format';

/**
 * @param { unknown } value
 * @param {{ t?: typeof TranslationService.getV2 }} [ctx]
 */
export function transformDescription(value, ctx) {
	const t = ctx?.t || TranslationService.getV2;

	if (value?.startsWith?.('$')) {
		const [category, tag] = value.split('-');
		const clean = value.replace('$', '');

		const fmtCategory = FormatUtils.replace([category]);
		const fmtTag = FormatUtils.replace([tag]);

		if (
			TranslationService.hasKey([
				`list.transactions.transaction.description.${clean}`,
				`list.transactions.transaction.description.${fmtCategory}`,
				`list.transactions.transaction.description.${fmtTag}`,
				`list.transactions.transaction.description.${fmtCategory}.${fmtTag}`,
			])
		) {
			return t([
				`list.transactions.transaction.description.${clean}`,
				`list.transactions.transaction.description.${fmtCategory}`,
				`list.transactions.transaction.description.${fmtTag}`,
				`list.transactions.transaction.description.${fmtCategory}.${fmtTag}`,
			]);
		}

		return FormatUtils.formatTag({ category: category, tag: tag }, { t });
	}

	return t([value, 'transaction.unknown'], {
		default: value,
	});
}

export function transformDate(value) {
	return format(parseISO(value || new Date().toISOString()), 'yyyy-MM-dd');
}
